const labelNext = (date, options) => {
    var _a;
    switch ((_a = options === null || options === void 0 ? void 0 : options.locale) === null || _a === void 0 ? void 0 : _a.code) {
        case "nb":
            return "Gå til neste måned";
        case "nn":
            return "Gå til neste månad";
        case "en":
            return "Go to next month";
        default:
            return "Gå til neste måned";
    }
};
const labelPrevious = (date, options) => {
    var _a;
    switch ((_a = options === null || options === void 0 ? void 0 : options.locale) === null || _a === void 0 ? void 0 : _a.code) {
        case "nb":
            return "Gå til forrige måned";
        case "nn":
            return "Gå til førre månad";
        case "en":
            return "Go to previous month";
        default:
            return "Gå til forrige måned";
    }
};
export const labelYearDropdown = (locale) => {
    switch (locale === null || locale === void 0 ? void 0 : locale.code) {
        case "nb":
            return "År";
        case "nn":
            return "År";
        case "en":
            return "Year";
        default:
            return "År";
    }
};
export const labelMonthDropdown = (locale) => {
    switch (locale === null || locale === void 0 ? void 0 : locale.code) {
        case "nb":
            return "Måned";
        case "nn":
            return "Månad";
        case "en":
            return "Month";
        default:
            return "Måned";
    }
};
export const labelNextYear = (localeCode) => {
    switch (localeCode) {
        case "nb":
            return "Gå til neste år";
        case "nn":
            return "Gå til neste år";
        case "en-GB":
            return "Go to next year";
        default:
            return "Gå til neste måned";
    }
};
export const labelPrevYear = (localeCode) => {
    switch (localeCode) {
        case "nb":
            return "Gå til forrige år";
        case "nn":
            return "Gå til førre år";
        case "en-GB":
            return "Go to next year";
        default:
            return "Gå til neste år";
    }
};
export const labels = {
    labelNext,
    labelPrevious,
};
export const labelWeekNumber = ({ localeCode, week, }) => {
    switch (localeCode) {
        case "nb":
            return `Uke ${week}`;
        case "nn":
            return `Veke ${week}`;
        case "en-GB":
            return `Week ${week}`;
        default:
            return `Uke ${week}`;
    }
};
export const labelWeekNumberButton = ({ localeCode, week, }) => {
    switch (localeCode) {
        case "nb":
            return `Velg uke ${week}`;
        case "nn":
            return `Vel veke ${week}`;
        case "en-GB":
            return `Pick week ${week}`;
        default:
            return `Velg uke ${week}`;
    }
};
export const labelWeek = (localeCode) => {
    switch (localeCode) {
        case "nb":
            return `Uke:`;
        case "nn":
            return `Veke:`;
        case "en-GB":
            return `Week:`;
        default:
            return `Uke:`;
    }
};
const modalLabelSingle = (localeCode) => {
    switch (localeCode) {
        case "nb":
            return `Velg dato`;
        case "nn":
            return `Vel dato`;
        case "en-GB":
            return `Pick a date`;
        default:
            return `Velg dato`;
    }
};
const modalLabelMultiple = (localeCode) => {
    switch (localeCode) {
        case "nb":
            return `Velg datoer`;
        case "nn":
            return `Vel datoar`;
        case "en-GB":
            return `Pick dates`;
        default:
            return `Velg datoer`;
    }
};
const modalLabelRanged = (localeCode) => {
    switch (localeCode) {
        case "nb":
            return `Velg start- og sluttdato`;
        case "nn":
            return `Vel start- og sluttdato`;
        case "en-GB":
            return `Pick a start and end date`;
        default:
            return `Velg start- og sluttdato`;
    }
};
const modalLabelMonth = (localeCode) => {
    switch (localeCode) {
        case "nb":
            return `Velg måned`;
        case "nn":
            return `Vel månad`;
        case "en-GB":
            return `Pick a month`;
        default:
            return `Velg måned`;
    }
};
export const modalLabel = (localeCode, variant) => {
    switch (variant) {
        case "single":
            return modalLabelSingle(localeCode);
        case "multiple":
            return modalLabelMultiple(localeCode);
        case "range":
            return modalLabelRanged(localeCode);
        case "month":
            return modalLabelMonth(localeCode);
        default:
            return modalLabelSingle(localeCode);
    }
};
export const modalCloseButtonLabel = (localeCode) => {
    switch (localeCode) {
        case "nb":
            return `Lukk`;
        case "nn":
            return `Lukk`;
        case "en-GB":
            return `Close`;
        default:
            return `Lukk`;
    }
};
//# sourceMappingURL=labels.js.map